var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashingMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#666",
    fill: "#FFF",
    width: 14,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 0h14v4H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#666",
    fill: "#6E6E6E",
    opacity: 0.9,
    cx: 7,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M.199 3.967h13.914"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M7 6h2.019M16 6h1.019"
  }))));
}
export default SvgWashingMachine;